<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Posição do Caminhão no Pátio</app-titulo>
      <app-subtitulo> Consulte a posição do caminhão na fila pela placa do cavalo. </app-subtitulo>
    </div>

    <div class="grid-outline">
      <div class="grid-header">
        <div class="intern-title">Consulta</div>
      </div>

      <form [formGroup]="form" (ngSubmit)="consultar()" class="form-consulta">
        <div class="busca-container">
          <p class="busca-instrucao">Digite a placa do cavalo para consultar a posição na fila</p>
          <div class="busca-input-wrapper">
            <input
              class="busca-input"
              id="TX_PLCA_CAVA"
              name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA"
              placeholder="ABC1D23"
              maxlength="8"
              (input)="onPlacaInput($event)"
            />
          </div>
          <span class="busca-erro" *ngIf="form.get('TX_PLCA_CAVA')?.invalid && form.get('TX_PLCA_CAVA')?.touched">
            Placa inválida. Use o formato ABC1D23 ou ABC-1D23.
          </span>

          <div class="botoes">
            <button class="btn-consultar" type="submit" [disabled]="isLoading">Consultar</button>
            <button class="btn-limpar" type="button" [disabled]="isLoading" (click)="limpar()">Limpar</button>
          </div>
        </div>
      </form>

      <div class="loading" *ngIf="isLoading">
        <span>Consultando...</span>
      </div>

      <div class="resultado" *ngIf="!isLoading && consultado && resultado">
        <div class="card-posicao">
          <span class="label">Posição na fila</span>
          <span class="valor">{{ resultado.POSICAO }}º</span>
        </div>

        <div class="card-vizinhos">
          <div class="vizinho">
            <span class="label">Caminhão atrás</span>
            <span class="placa">{{ resultado.TX_PLCA_PROX || "---" }}</span>
          </div>
          <div class="vizinho atual">
            <span class="label">Este caminhão</span>
            <span class="placa">{{ resultado.TX_PLCA_CAVA }}</span>
          </div>
          <div class="vizinho">
            <span class="label">Caminhão à frente</span>
            <span class="placa">{{ resultado.TX_PLCA_ANTR || "---" }}</span>
          </div>
        </div>

        <div class="card-detalhes">
          <div class="linha"><strong>Nº do ticket:</strong> #{{ resultado.PK_GATE_ENTR }}</div>
          <div class="linha"><strong>Tipo de fila:</strong> {{ resultado.TP_FILA }}</div>
          <div class="linha" *ngIf="resultado.NM_DTNR"><strong>Destinatário:</strong> {{ resultado.NM_DTNR }}</div>
          <div class="linha" *ngIf="resultado.TX_CRGA"><strong>Produto:</strong> {{ resultado.TX_CRGA }}</div>
          <div class="linha" *ngIf="resultado.TX_JANELA"><strong>Janela:</strong> {{ resultado.TX_JANELA }}</div>
          <div class="linha"><strong>Entrada:</strong> {{ resultado.DT_GATE_ENTR | date: "dd/MM/yyyy HH:mm" }}</div>
        </div>
      </div>

      <div class="resultado-vazio" *ngIf="!isLoading && consultado && !resultado">
        <p>Caminhão não encontrado no pátio.</p>
      </div>
    </div>
  </div>
</app-layout>
